import React from 'react';
import { toNewDomain } from '../../utils/brand';
import { BaseButton } from '@repo/common';

const FeatureMoved = () => (
  <div className='flex min-h-screen flex-col items-center justify-center p-4 tabletH:p-20 tabletH:pt-0 text-center bg-grayscale-gray01'>
    <div className='flex flex-col gap-6 items-center'>
      <div className='flex flex-col gap-2 items-center max-w-[620px]'>
        <h2 className='typo-b18Strong tabletH:typo-h6 text-grayscale-gray09'>
          This feature has moved to Koready! 🚀
        </h2>
        <p className='typo-b12 tabletH:typo-b16 text-grayscale-gray09'>
          To provide you with a better experience, this menu is now exclusively
          available on our new website. Head over to Koready to access this
          feature.
        </p>
      </div>
      <BaseButton
        onClick={() => (window.location.href = toNewDomain())}
        type='primary'
        size='l'
        hideIcon
      >
        Continue to New Website
      </BaseButton>
    </div>
  </div>
);

export default FeatureMoved;
